import { CaddyFillerMaterialDiameter, RodRequestCaddy } from '@bechtel/types';

export interface CaddyCardProps {
  caddy: RodRequestCaddy;
  onDeleteCaddy: (caddy: RodRequestCaddy) => void;
  onEditCaddy?: (caddy: RodRequestCaddy) => void;
  canEditCaddy?: boolean;
}

export interface RodConfigCardProps {
  rod: CaddyFillerMaterialDiameter;
  fillerMaterial: string;
}
